<template>
  <v-dialog v-model="dialogPackageDetail" persistent max-width="70%">
    <v-card>
      <v-card-title>
        <span class="title">Đóng bao ngày {{currentTime | display_date('DD-MM-YYYY')}}</span>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg7 md7 sm7>
            <v-layout row wrap pa-3>
              <v-flex lg12 md12 sm12 pa-0 ma-0>
                <v-checkbox label="Sử dụng máy đọc barcode" v-model="useBarcodeReader"></v-checkbox>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-text-field
                  label="Mã vận đơn"
                  ref="trancode"
                  v-model="currentTransaction.TransactionCode"
                  class="input-group--focused"
                  @input="codeChanged"
                  @keyup.enter="manualChanged"
                  :disabled="readOnly"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-data-table
                  :headers="headers"
                  :items="currentItem.Packages"
                  :options.sync="pagination"
                  :footer-props="items_per_page"
                  :must-sort="true"
                  :loading="loading"
                  :mobile-breakpoint="100"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.TransactionCode }}</td>
                      <td>{{ item.FeeShip | currency}}</td>
                      <td class="text-center">
                        <v-icon v-if="!readOnly" small @click="deleteTransaction(item.ID)">delete</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg5 md5 sm5 pl-3 pr-2>
            <v-layout row wrap pl-5>
              <v-flex lg12 md12 sm12 pa-0>
                <v-text-field
                  label="Mã bao hàng"
                  disabled
                  v-model="currentItem.PackageCode"
                  class="input-group--focused"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <h-currency-input
                  label="Số gói hàng"
                  v-model="currentItem.Volume"
                  :decimal="0"
                  class="input-group--focused"
                  disabled
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <h-currency-input
                  label="Tổng phí ship"
                  v-model="currentItem.Amount"
                  :decimal="0"
                  class="input-group--focused"
                  disabled
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <v-text-field
                  label="Tổng cân nặng"
                  type="number"
                  v-model="currentItem.Weight"
                  class="input-group--focused"
                  :rules="requireRules"
                  :disabled="readOnly"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <v-select
                  class="pa-0"
                  label="Kho nhận"
                  :items="warehouses"
                  v-model="currentItem.ReceivePlaceID"
                  item-text="Name"
                  item-value="ID"
                  :disabled="readOnly"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="closePopup">Hủy</v-btn>
        <v-btn v-if="!readOnly" color="blue darken-1" text @click="saveItem">Đóng bao</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Vue from 'vue';
import _ from "lodash";
import moment from "moment";
import { getCurrentTime, sendErrorNotice } from "@/commons/utils";
import { request_list } from '@/commons/hpod';
export default {
  name: "big-package-popup",
  data() {
    let dataType = configs.DATA_TYPE;
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 5;
    return {
      useBarcodeReader: true,
      currentTransaction: {
        TransactionCode: ""
      },
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Phí ship",
          value: "FeeShip",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: configPaging,
      items_per_page: { "items-per-page-options": [5] },
      currentTime: getCurrentTime()
    };
  },
  props: ["dialogPackageDetail", "readOnly"],
  watch: {
    dialogPackageDetail() {
      if (this.dialogPackageDetail) {
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    }
  },
  computed: {
    ...mapState({
      currentItem: state => state.bigPackage.selected,
      loading: state => state.bigPackage.loading,
      warehouses: state => state.commons.stores,
    })
  },
  methods: {
    closePopup() {
      window.getApp.$emit('REQUEST_DELETE_DATA', 0, 'Bạn muốn hủy thao tác nhập bao?');
    },
    filter_data: function() {
      if (this.currentItem.ID > 0) {
        var param = {
          pagination: this.pagination
        };
        this.$store.dispatch("bigPackage/getDetail", {'id': this.currentItem.ID, 'param': param});
      }
    },
    deleteTransaction(id) {
      _.remove(this.currentItem.Packages, pkg => pkg.ID === id);
      this.currentItem.Volume = this.currentItem.Packages.length;
      this.currentItem.Amount =  _.sumBy(this.currentItem.Packages, 'FeeShip');
      this.$nextTick(() => this.$refs.trancode.focus());
    },
    saveItem() {
      const selectedStore = _.find(this.warehouses, {ID: this.currentItem.ReceivePlaceID})
      if(selectedStore) {
        this.currentItem.StoreShortName = selectedStore.ShortName
      }
      this.$store.dispatch("bigPackage/setDetail", {
        data: this.currentItem,
        id: this.currentItem.ID
      });
      this.$emit("closePopup");
    },
    manualChanged() {
      if (this.currentTransaction.TransactionCode !== "" && !this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    codeChanged() {
      if (this.currentTransaction.TransactionCode !== "" && this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    appendTransactionCode: _.debounce(
      function() {
         var param = {
            filter: [{
                column: "TransactionCode",
                value: this.currentTransaction.TransactionCode,
                condition: "s_equal"
            },
            {
                column: "BigPackageID",
                value: 0,
                condition: "equal"
            }]
        };
        const checkTran = _.find(this.currentItem.Packages, {TransactionCode: this.currentTransaction.TransactionCode})
        if(checkTran) {
          this.currentTransaction = {
            TransactionCode: ""
          };
          this.$nextTick(() => this.$refs.trancode.focus());
          sendErrorNotice('Gói hàng đã tồn tại.')
          return;
        }
        request_list('storemanager', ret => {
          if(ret.data.length > 0) {
            this.currentItem.Packages.unshift(ret.data[0]);
            this.currentItem.Volume = this.currentItem.Packages.length;
            this.currentItem.Amount =  _.sumBy(this.currentItem.Packages, 'FeeShip');
            this.currentTransaction = {
              TransactionCode: ""
            };
            this.$nextTick(() => this.$refs.trancode.focus());
          }
          else {
            sendErrorNotice('Gói hàng không tồn tại hoặc đã đóng trong bao khác.')
          }              
        }, Vue.http, param, this.$store.state.authentication.token);
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
   
  },
  mounted() {
    this.$store.dispatch("commons/getAllStores");
    this.$root.$on("CONFIRMED_REMOVE_DATA", () => {
      this.$emit("closePopup");
    });
  },
  beforeDestroy() {
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
